import PropTypes from 'prop-types';

import { CurrencyPropType } from '../../prop-types/currency';

export const AvailableDutiesOptionsProptype = PropTypes.arrayOf(
  PropTypes.shape({
    additionalOptionEnum: PropTypes.string,
    additionalOptionValue: PropTypes.shape({
      prepaidDuty: PropTypes.string,
    }),
    price: CurrencyPropType,
  }),
);

/**
 * @typedef {object} AvailableDutyOption
 * @property {string} additionalOptionEnum
 * @property {{ prepaidDuty: string }} additionalOptionValue
 * @property {import('../../prop-types/currency').Currency} price
 */

/**
 * @typedef {AvailableDutyOption[]} AvailableDutiesOptions
 */
